<template>
  <div ref="targetEl" :class="[classes.wrapper]">
    <WinButton
      :option="option"
      :class="[classes.optionButton, 'test-option', $attrs.class]"
      :isDraw="isDraw"
      @click="handleButtonClick"
    />
  </div>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import WinButton from "../../WinButton.vue";
import { computed, defineComponent, provide, ComputedRef } from "vue";
import { injectBetData } from "@fresh8/ad-data-composition/src/betData";
import { composePopoverForm } from "@fresh8/ad-data-composition/src/popoverForm";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { Option } from "@fresh8/types/src/betData";

import { injectCardNumber, useAnalytics } from "../../../hooks/useAnalytics";

function composeBetOption(optionId: string) {
  const { options } = injectBetData();

  return computed(() => options.value[optionId]);
}

const useListOptionStyles = createUseStyles({
  wrapper: {
    display: "flex",
    height: "100%",
    width: "100%"
  },
  optionButton: {
    flex: 1,
    display: "flex",
    fontSize: "14px",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    margin: 0
  }
});

export default defineComponent({
  components: { WinButton },
  props: {
    optionId: { type: String, required: true },
    marketId: { type: String, required: true },
    isDraw: { type: Boolean, required: false, default: false },
    stagger: { type: Number, default: 0 }
  },
  setup(props) {
    provide("button-transition-stagger", props.stagger);
    const { brand } = injectBrand();
    const classes = useListOptionStyles();
    const cardNumber = injectCardNumber();
    const option = composeBetOption(props.optionId);
    const { handleClick } = useAnalytics(
      {
        ...props,
        cardNumber: cardNumber,
        optionName: option.value.name?.full
      },
      "Odds Button"
    );

    const handleButtonClick = () => {
      if (option.value.suspended || !props.optionId) return;

      handleClick();
    };

    const { targetEl } = composePopoverForm("Market Button", [
      {
        type: "button",
        get: () => brand.value.adTemplate.market.oddsButton,
        set: (value: string) =>
          (brand.value.adTemplate.market.oddsButton = value)
      }
    ]);

    return {
      classes,
      handleButtonClick,
      option,
      targetEl
    };
  }
});
</script>
